<template>
  <div class="TopBar Sticky" :class="{ sticky }">
    <Wrap class="xl">
      <MainLogo format="png" type="black" />
      <div aria-label="Main" class="menu" :class="{ show: doShowMenu }" role="navigation">
        <MenuLink
          v-for="(link, index) in menu"
          :key="index"
          :class="{ last: (index === menu.length - 1) }"
          :index="index"
          :link="link" />
        <AuthMenu />
      </div>
      <div class="mobileContainer">
        <div
          ref="hamburger"
          class="hamburger"
          @click="doShowMenu = !doShowMenu"
          @keypress.enter="doShowMenu = !doShowMenu">
          <Icon :name="doShowMenu ? 'cross' : 'menu'" />
        </div>
        <transition name="slide-side">
          <div v-if="doShowMenu" ref="mobileMenu" class="mobileMenu" role="navigation">
            <MenuLink
              v-for="(link, index) in menu"
              :key="link.name"
              :class="{ last: (index === menu.length - 1) }"
              :index="index"
              :link="link"
              @click="doShowMenu = false" />
            <AuthMenu />
          </div>
        </transition>
      </div>
    </Wrap>
  </div>
</template>

<script>
import AuthMenu from './AuthMenu'
import MainLogo from './MainLogo'
import MenuLink from './MenuLink'
import Sticky from '../../mixins/Sticky'
import { actions } from '../../utils'

export default {
  mixins: [Sticky],
  components: { AuthMenu, MainLogo, MenuLink },
  data() {
    return {
      doShowMenu: false,
      menu: [
        // {
        //   to: 'Index',
        //   label: 'Home',
        // },
      ],
    }
  },
  methods: {
    checkClickLocation(event) {
      if (!this.$refs.mobileMenu || !this.doShowMenu) return

      if (!['hamburger', 'mobileMenu'].some(ref => this.$refs[ref].contains(event.target))) {
        this.doShowMenu = false
      }
    },
    ...actions(),
  },
  async beforeMount() {
    this.$offEvents = await this.ON({
      click: this.checkClickLocation,
    })
  },
  beforeDestroy() {
    this.$offEvents && this.$offEvents()
  },
}
</script>

<style lang="scss">
$_burger-width: 2.25rem;
$_border-bottom: $main-darker;

.TopBar {
  background-color: $white;
  border-bottom: 1px solid $_border-bottom;
  height: $topbar-height-compact;
  position: absolute;
  top: 0;
  width: 100%;
  z-index: 7;
  @include md {
    height: $topbar-height;
  }

  > .Wrap {
    align-items: center;
    display: flex;
    height: 100%;
    justify-content: flex-end;
    padding: 1rem 0.5rem;
    @include xs {
      padding-left: 1.75rem;
      padding-right: 1.75rem;
    }
    @include md {
      border: 0;
      padding-left: 0.5rem;
      padding-right: 0.5rem;
      padding-top: 1rem;
    }
    @include lg {
      padding-left: 1rem;
      padding-right: 1rem;
    }
    @include xl {
      padding-left: 2rem;
      padding-right: 2rem;
    }

    .MainLogo {
      margin-right: auto;
    }
  }

  .menu {
    color: $white;
    display: none;
    float: right;
    padding: 1.5rem 0;
    @include md {
      display: block;
      padding: 0;
    }
    @include lg {
      padding: 0.5rem 0;
    }
  }

  .hamburger {
    background: $white;
    border-radius: $radius;
    color: $main;
    cursor: pointer;
    display: inline-block;
    font-size: $h3;
    height: $_burger-width;
    line-height: $_burger-width;
    margin-top: 0.5rem;
    position: relative;
    text-align: center;
    width: $_burger-width;
    z-index: 11;
    @include md {
      float: right;
    }
  }

  .mobileContainer {
    float: right;
    @include md {
      display: none;
    }
  }

  .mobileMenu {
    align-items: center;
    background: $main;
    bottom: 0;
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: center;
    left: 20%;
    position: fixed;
    text-align: center;
    top: 0;
    width: 80%;
    z-index: 10;

    .AuthMenu {
      display: block;
    }
  }
}

// @animation
.slide-side-enter-active,
.slide-side-leave-active {
  @include trans;
  opacity: 1;
  transform: translateX(0);
}

.slide-side-enter,
.slide-side-leave-to {
  opacity: 0;
  transform: translateX(300px);
}
</style>
